import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

interface Browser {
  name: string;
  version: string;
}

@Injectable({
  providedIn: 'root'
})
export class DetectBrowserService {
  private _userAgent = navigator.userAgent;
  private _browser: Browser;
  constructor(
    private _platform: Platform
  ) {
    // Extract browser information
    const userAgentMatch = this._userAgent.match(/(\w+)\/(\d+\.\d+(?:\.\d+)?(?:\.\d+)?)/g);
    const userAgentOffset = userAgentMatch && ((userAgentMatch.length > 2) && !(/^(ver|cri|gec)/.test(userAgentMatch[1])) ? 1 : 0);
    const userAgentObject = userAgentMatch && userAgentMatch[(userAgentMatch.length - 1) - (userAgentOffset || 0)].split('/');
    this._browser = {
      name: userAgentObject && userAgentObject[0],
      version: userAgentObject && userAgentObject[1]
    };

    // Extract browser information for Chrome, Firefox, Safari, Edge, and Opera
    if (this._platform.BLINK || this._platform.WEBKIT || this._platform.EDGE || this._platform.TRIDENT) {
      const browserMatch = this._userAgent.match(/(Chrome|Firefox|Safari|Edg|OPR)\/(\d+\.\d+(?:\.\d+)?(?:\.\d+)?)/);
      this._browser = {
        name: browserMatch && browserMatch[1],
        version: browserMatch && browserMatch[2]
      };
    }

    // Extract browser information for IE
    if (this._platform.TRIDENT) {
      this._browser.name = 'IE';
      const version = this._userAgent.match(/(MSIE |rv:)(\d+(\.\d+)?)/);
      this._browser.version = version && version[2];
    }
  }

  // Get browser information
  getBrowser(): Browser {
    return this._browser;
  }

  // Get platform information
  getPlatform(): any {
    return this._platform;
  }
}
